'use strict';

import template from './footer.html';

const saFooter = [
  function () {
    return {
      template: template,
      replace: true,
      scope: {},
      bindToController: true,
      controllerAs: 'ctrl',
      controller: [
        '$window',
        'config',
        'userModel',

        function ($window, config, userModel) {
          this.blogUrl =  config.blogUrl;
          this.pressPageUrl = config.pressPageUrl;
          this.currentYear = (new Date()).getFullYear();
          this.userModel = userModel;

          $window.SA = $window.SA || {};
          this.shouldShowTeamPage = $window.SA.country !== 'LT';
        }
      ]
    };
  }
];

export default saFooter;



// WEBPACK FOOTER //
// ./app/src/directives/footer.js